export default "__VITE_ASSET__ECmaiHMu__"